























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import ImportPage from "@/lib/import-page";
import { mixins } from "vue-class-component";

@Component({
  components: {},
})
export default class ImportUnit extends mixins(AbpBase, ImportPage) {
  importPageName = "Unit";
  //filters
  current: number = 0;
  unitFileId: number = 0;
  spinShow: boolean = false;

  get countItems() {
    return this.$store.state.unitImport.countItems;
  }
  get countImportedItems() {
    return this.$store.state.unitImport.countImportedItems;
  }
  get list() {
    return this.$store.state.unitImport.itemsImported;
  }
  get loading() {
    return this.$store.state.unitImport.loading;
  }
  create() {}

  activeStep(next: boolean) {
    if (next && this.current < 1) {
      this.current++;
    }
    if (!next && this.current > 0) {
      this.current--;
    }
  }

  nextStep() {
    this.activeStep(true);
  }

  backStep() {
    this.activeStep(false);
  }
  async exportToExcel() {
    await this.$store.dispatch({
      type: "unitImport/export",
      data: this.unitFileId,
    });
  }

  columns = [
    {
      title: this.L("ErrorMsg"),
      key: "errorMessage",
      fixed: "left",
      width: 200,
    },
    {
      title: this.L("Code"),
      key: "code",
    },
    {
      title: this.L("Name"),
      key: "name",
    },
    {
      title: this.L("IsImported"),
      align: "center",
      width: 100,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Icon",
            {
              props: {
                size: 36,
                type: Util.getIsImportedIcon(params.row.isImported),
              },
            },
            ""
          ),
        ]);
      },
    },
  ];

  async created() {
    if (!this.checkSignalConnected()) return;
    if (Util.abp.signalr && Util.abp.signalr.hubs.common.state == 1) {
      Util.abp.signalr.hubs.common.on("Import.Unit", (notification) => {
        this.processNotifierImportUnit(notification);
      });
    } else {
      abp.event.on("abp.signalr.connected", () => {
        Util.abp.signalr.hubs.common.on("Import.Unit", (notification) => {
          this.processNotifierImportUnit(notification);
        });
      });
    }
  }
  processNotifierImportUnit(notification: any) {
    if (notification.unitFileId === this.unitFileId) {
      this.$store.commit({
        type: "unitImport/processNotifier",
        data: notification,
      });
    }
  }
  resetList() {
    this.$store.commit({
      type: "unitImport/resetList",
    });
  }

  handleBeforeUpload(file) {
    const fileExt = file.name.split(".").pop().toLocaleLowerCase();

    if (fileExt === "xlsx" || fileExt === "xls") {
      let data = new FormData();
      data.append("file", file);
      this.spinShow = true;
      try {
        this.$store
          .dispatch("unitImport/uploadImportUnitFile", data)
          .then((res) => {
            this.resetList();
            this.activeStep(true);
            this.unitFileId = res;
            this.spinShow = false;
          })
          .catch(() => {
            this.spinShow = false;
          });
      } catch (error) {
        this.spinShow = false;
      }
    }
    return false;
  }
}
